import SemaphoreDialog from '@/components/semaphores/SemaphoreDialog';
import { useApplication } from '@/hooks/useApplication';
import { getMostSevereLevel, validateSemaphores } from '@/util/validation/validation';
import TrafficIcon from '@mui/icons-material/Traffic';
import { FC, useState } from 'react';
import StyledTreeItem from './StyledTreeItem';
import TreeLabel from './TreeLabel';

const TreeSemaphores: FC = () => {
  const { application } = useApplication();
  const [openManager, setOpenManager] = useState(false);
  const errors = (application && validateSemaphores(application.semaphores)) || [];

  return (
    <>
      <StyledTreeItem
        itemId='semaphores'
        label={
          <TreeLabel
            icon={TrafficIcon}
            label='Semaphores'
            {...(!!errors.length && { error: getMostSevereLevel(errors) })}
          />
        }
        onClick={() => setOpenManager(true)}
      />
      <SemaphoreDialog open={openManager} onClose={() => setOpenManager(false)} />
    </>
  );
};

export default TreeSemaphores;
